import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains GL IDC Mapping: The association(s) between general ledger expenses and indirect cost categories.',
    name: 'GL Expense IDC Functionalization',
    partialId: PartialId.Standard.create('gl_exp_idc_funcl'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
